import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import {
  brandPolicyPath,
  brandPolicyTitle,
  getBrand,
  type PolicyDocument,
} from '../../constants/brands';
import { policyKindFromSlug } from '../../services/policyService/policyKinds';
import PolicyPage from './index';

const FILE_DOCS = new Set<PolicyDocument>([
  'terms',
  'privacy',
  'cancellation',
  'account-deletion',
  'host-agreement',
  'renter-agreement',
]);

/** `/policies/:doc/versions/:id` — one published or superseded version. The static file is the fallback. */
const PolicyVersionPage: React.FC = () => {
  const { doc, id } = useParams();
  const kind = policyKindFromSlug(doc);
  if (!kind || !id) return <Navigate to="/policies/terms" replace />;
  const brand = getBrand();
  const slug = doc as PolicyDocument;
  const contentPath = FILE_DOCS.has(slug) ? brandPolicyPath(slug, brand) : null;
  const title = FILE_DOCS.has(slug) ? brandPolicyTitle(slug, brand) : 'Policy';
  return <PolicyPage title={title} contentPath={contentPath} kind={kind} versionId={id} />;
};

export default PolicyVersionPage;
